<template>
    <modal name="recommenddialog" :height="600" :width="800">
        <div class="maindisplay">
            <!--押したタグの表示-->
            <div class="displaytitle">
                <span class="recommendkey">{{recommendkey}}</span><span>と関連している展示物</span>
            </div>
            <!--推薦した展示物の表示-->
            <div class="itemdisplay">
                <div class="itemcard" 
                v-for="(item,index) in recommend" :key="index"
                @click="choosely(index, item)">
                    <div>
                        <img :src="item.url" alt="">
                    </div>
                    <div class="details">
                        <span>{{item.name |ellipsis}}</span>
                        <span class="country"><br>{{item.country |ellipsis}}</span>
                        <span v-for="(word, index) in item.details" :key="index"><br> {{word | ellipsis}}</span>
                    </div>
                </div>
            </div>
            <!--ボタンの表示-->
            <div class="button">
                <b-button variant="outline-primary" class="check" @click="check">確認</b-button>
                <b-button variant="outline-primary" class="cancel" @click="cancel">取消</b-button>
            </div> 
        </div>
    </modal>
</template>

<script>
    import axios from 'axios'

    export default {
        props: {
            recommendkey: {
                type: String
            },
        },
        data () {
            return{
                recommend: [],
                recommendword: this.recommendkey,
                keywordlist: []
            }
        },

        methods: {
            // 推薦展示物を取得(details_main画面でのタグを押した場合処理する)
            selectRecommendids (postkey) {
                if (postkey !== ""){
                    this.keywordlist.push(postkey)
                }
                window.console.log("do post")
                window.console.log(this.keywordlist)
                axios.post('/api/recommenddialog',{
                    keywordlist: this.keywordlist,
                }).then((res) =>{
                    window.console.log(res)
                    if (res.data.flg == 0) {
                        this.recommend = res.data.recommenditems
                        window.console.log("post done")
                        window.console.log(this.recommend)
                    }else{
                        alert("似ている展示物が存在してないそうです。")
                    }
                })
            },

            // 出力の文字数の制限
            filters: {
                ellipsis (value) {
                    if (!value) return ''
                    if (value.length > 9) {
                        return value.slice(0, 8) + '...'
                    }
                    return value
                },
            },

             // 確認ボタンを押した場合
            check: function(){
                this.$emit('showRecommend', this.recommendkey, this.recommend)
                this.$modal.hide('recommenddialog')
            },

            // 取消ボタンを押した場合
            cancel: function(){
                this.$modal.hide('recommenddialog')
                this.keywordlist = []
            },
        }
    }
</script>

<style>
    .maindisplay{
        width: 800px;
        height: 600px;
        text-align:center;
        margin: auto;
    }

    .maindisplay .displaytitle{
        width: 800px;
        height: 30px;
        text-align: center;
    }

    .maindisplay .displaytitle span{
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
    }

    .maindisplay .displaytitle .recommendkey{
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #e66852;
        font-size: 20px;
        font-weight: bold;
    }

    .maindisplay .itemdisplay{
        width: 700px;
        height: 500px;
        margin: auto;
        text-align: center;
    }

    .maindisplay .itemdisplay .itemcard{
        width: 200px;
        height: 230px;
        text-align:center;
        margin: 15px;
        padding: 4px;
        background-image: linear-gradient(to top, rgba(166, 191, 243, 0), rgb(160, 200, 238));
        float: left;
    }

    .maindisplay .itemdisplay .itemcard img{
        width: 90px;
        height: 90px;
        margin: auto;
    }

    .maindisplay .itemdisplay .itemcard .details{
        max-width: 160px;
        max-height: 130px;
        text-align:center;
        margin: auto;
    }

    .maindisplay .itemdisplay .itemcard .details span{
        text-align:center;
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #333333;
        font-size: 16px;
        font-weight: bold;
    }

    .maindisplay .itemdisplay .itemcard .details .country{
        text-align:center;
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: grey;
        font-size: 12px;
        font-weight: bold;
    }

    .maindisplay .button{
        margin: 6px;
        text-align: center;
    }

    .maindisplay .button .check{
        margin-right: 20px;
        text-align: center;
    }

    .button .cancel{
        margin-left: 20px;
        text-align: center;
    }

</style>